/* قطرات "شنو بمي الإسالة": الضغط على أي قطرة يفعّلها ويعرض شرحها */
if (!customElements.get('hayat-hotspots')) {
  customElements.define(
    'hayat-hotspots',
    class HayatHotspots extends HTMLElement {
      connectedCallback() {
        this.triggers = Array.from(this.querySelectorAll('[data-spot]'));
        this.infos = Array.from(this.querySelectorAll('[data-info]'));
        this.triggers.forEach((trigger) => {
          trigger.addEventListener('click', () => this.activate(trigger.dataset.spot));
        });

        // بالمحرر: اختيار النقطة من القائمة يفعّلها
        this.onBlockSelect = (event) => {
          const chip = this.querySelector(`[data-spot][data-shopify-editor-block*="${event.detail.blockId}"]`);
          if (chip) this.activate(chip.dataset.spot);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      activate(index) {
        this.triggers.forEach((trigger) => {
          trigger.setAttribute('aria-pressed', String(trigger.dataset.spot === index));
        });
        this.infos.forEach((info) => {
          info.classList.toggle('is-active', info.dataset.info === index);
        });
      }
    }
  );
}
